<template>
  <div class="single-tag-item">
    <div class="left">
      <input type="checkbox" v-model="checked" @change="emitChecked" />
      <span>{{ tagData.tag_name }}</span>
    </div>
    <div class="right">
      <div class="controls">
        <a-button
          @click="editTag"
          type="primary"
          style="
            width: 107px;
            height: 32px;
            border: none;
            background: #b2bac7;
            border-radius: 2px;
            padding: 5px 12px;
            margin: 0px 16px;
            font-size: 16px;
            line-height: 22px;
            color: #ffffff;
          "
        >
          <span class="material-icons">border_color</span>
          Rename
        </a-button>
        <a-button
          @click="removeTag(tagData)"
          style="
            padding: 5px 12px;
            width: 94px;
            height: 32px;
            border: 1px dashed #dfe1e6;
            box-sizing: border-box;
            border-radius: 2px;
            margin: 0px 16px;
            background: #fff;
            font-size: 16px;
            line-height: 22px;
            color: #b2bac7;
          "
          type="primary"
        >
          <span class="material-icons">delete</span>
          Delete
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    tagData: {
      type: Object,
    },
    checkAll: {
      type: Boolean,
    },
  },
  watch: {
    checkAll(val) {
      if (val) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.emitChecked();
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    removeTag(tag) {
      const confirmProp = {
        title: this.$t(
          `You are about to permanently delete these items from your site. This action cannot be undone. ‘Cancel’ to stop, ‘Yes’ to delete.`,
          { name: tag.tag_name }
        ),
        okCallback: async () => {
          try {
            let res = await api.deleteTag({
              tag_id: tag.tag_id,
            });
            console.log(res.data);
            this.openToast(this.$t("adminTags.deleteOk"));
            this.$emit("reloadTags");
          } catch (error) {
            console.warn(error);
            this.customError(this.$t("adminTags.fail"));
          }
        },
      };
      this.EventBus.$emit("confirm", confirmProp);
    },
    emitChecked() {
      this.$emit("isChecked", {
        id: this.tagData.tag_id,
        checked: this.checked,
      });
    },
    editTag() {
      let obj = {
        id: this.tagData.tag_id,
        name: this.tagData.tag_name,
      };
      this.$emit("editTag", obj);
    },
  },
};
</script>

<style scoped lang='scss'>
.single-tag-item {
  border-bottom: 1px solid #dfe1e6;
  padding: 0 0 0 16px;
  height: 55px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:last-of-type {
    border: none;
  }
  .left,
  .right {
    display: flex;
    align-items: center;
  }
  .left {
    min-width: 100px;
    input {
      margin: 0 10px 0 0;
    }
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #001529;
      justify-content: flex-start;
    }
  }
  .right {
    justify-content: space-between;
    .controls {
      .material-icons {
        font-size: 12px;
        margin: 0 3px 0 0;
        display: inline-block;
      }
    }
    .count {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #001529;
    }
  }
}
</style>